import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchSingleBlogPost, fetchRelatedBlogPosts, subscribeToNewsletter } from "../api/GlobalApi";
import { Helmet } from "react-helmet-async";

function SingleBlogPost() {
    const { slug } = useParams();
    const [app, setApp] = useState(null);
    const [relatedApps, setRelatedApps] = useState([]);
    const [loading, setLoading] = useState(true);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug) return;

        const loadBlog = async () => {
            try {
                const response = await fetchSingleBlogPost(slug);
                const appData = response.data?.data || response.data || response;
                setApp(appData);

                if (appData.category_id) {
                    const related = await fetchRelatedBlogPosts(appData.category_id, appData.id);
                    setRelatedApps(related || []);
                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching blog:", error);
                setLoading(false);
            }
        };

        loadBlog();
    }, [slug]);

    if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );
    if (!app) return <p>Blog not found</p>;

    // Parse tags from JSON string if needed
    let tags = [];
    try {
        tags = JSON.parse(app.meta_keywords || "[]").map((t) => t.value);
    } catch (e) {
        tags = [];
    }

    function formatDate(dateString) {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric"
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setError(null);

        try {
            const response = await subscribeToNewsletter(name, email);
            setMessage(response.message);
            setName("");
            setEmail("");
        } catch (err) {
            if (err.response?.data?.errors) {
                const errorMessages = Object.values(err.response.data.errors).flat().join(", ");
                setError(errorMessages);
            } else {
                setError("Something went wrong. Please try again.");
            }
            } finally {
            setLoading(false);
        }
    };

    return (
        <main className="main-content">
            <Helmet>
                <title>{app.title || app.title}</title>
                <meta name="description" content={app.meta_description} />
                <meta name="keywords" content={tags.join(", ")} />
            </Helmet>

            {/* Breadcrumb */}
            <div style={{ marginBottom: "24px", color: "#5f6368", fontSize: "14px" }}>
                <Link to="/blogs" style={{ color: "#5f6368", textDecoration: "none" }}>Blog</Link>
                <span style={{ margin: "0 8px" }}>›</span>
                <Link to={`/blogs/category/${app.category_slug}`} style={{ color: "#5f6368", textDecoration: "none" }}>
                    {app.category}
                </Link>
                <span style={{ margin: "0 8px" }}>›</span>
                <span style={{ color: "#202124" }}>{app.title}</span>
            </div>

            {/* Article Header */}
            <article className="blog-article-header">
                <Link to={`/blogs/category/${app.category_slug}`} className="blog-article-category" style={{textDecoration: "none"}}>{app.category}</Link>
                <h1 className="blog-article-title">{app.title}</h1>
                <div className="blog-article-meta">
                    <Link to={`/blogs/author/${app.author_id}`} className="blog-author" style={{textDecoration: "none"}}>
                        <img src={app.avatar_url} alt={app.author} className="blog-author-avatar" />
                        <span>{app.author}</span>
                    </Link>
                    <span>•</span>
                    <span>{new Date(app.created_at).toLocaleDateString()}</span>
                    <span>•</span>
                    <span>{app.views_count} Views</span>
                </div>
            </article>

            {/* Featured Image */}
            {app.featured_image_url && (
                <div className="blog-article-image" style={{backgroundImage: `url(${app.featured_image_url})`, backgroundSize: "cover", backgroundPosition: "center" }}>
                    {/* <img src={app.featured_image_url} alt={app.title} style={{ width: "100%", borderRadius: "12px" }} /> */}
                </div>
            )}

            {/* Content */}
            <div
                className="blog-article-content"
                dangerouslySetInnerHTML={{ __html: app.content }}
            ></div>

            {/* Tags */}
            {/* {tags.length > 0 && ( */}
                <div className="blog-tags blog-article-content">
                    {app.tags?.map((tag) => (
                        <Link key={tag.id} to={`/blogs/tag/${tag.slug}`} className="blog-tag">
                            {tag.name}
                        </Link>
                    ))}
                </div>
            {/* )} */}

            {/* <!-- Social Share --> */} 
            <div className="social-share"> 
                <button className="social-share-btn" title="Share on Twitter"> 
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#1DA1F2"> <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/> </svg> 
                </button> 
                <button className="social-share-btn" title="Share on Facebook"> 
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#1877F2"> <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/> </svg> 
                </button> 
                <button className="social-share-btn" title="Share on LinkedIn"> 
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#0A66C2"> <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/> <circle cx="4" cy="4" r="2"/> </svg> 
                </button> 
                <button className="social-share-btn" title="Copy Link"> 
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#5f6368"> <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/> <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/> </svg> 
                </button> 
            </div>

            {/* <!-- Author Bio --> */} 
            <section 
                className="section" 
                style={{
                    maxWidth: "800px",
                    margin: "60px auto",
                    padding: "24px",
                    background: "#f8f9fa",
                    borderRadius: "12px"
                }}
                > 
                <div 
                    style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "start"
                    }}
                > 
                    <div 
                    style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        background: "linear-gradient(45deg, #4285f4, #34a853)",
                        backgroundImage: `url(${app.avatar_url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        flexShrink: 0
                    }}
                    ></div> 

                    <div> 
                    <Link to={`/blogs/author/${app.author_id}`} style={{textDecoration: "none"}}>
                        <h3 
                            style={{
                            fontSize: "20px",
                            fontWeight: 500,
                            marginBottom: "8px",
                            color: "#202124"
                            }}
                        >
                            {app.author}
                        </h3> 
                    </Link>

                    <p style={{color: "#5f6368", fontSize: "14px", marginBottom: "12px"}}>
                        Senior Gaming Editor
                    </p> 

                    <p style={{color: "#5f6368", fontSize: "14px", lineHeight: "1.6"}}>
                        Sarah is a passionate gamer and technology writer with over 8 years of 
                        experience in the gaming industry. She specializes in mobile gaming 
                        reviews and industry trends. When she's not testing the latest games, 
                        you can find her streaming on Twitch or attending gaming conventions.
                    </p> 
                    </div> 
                </div> 
            </section>


            {/* Related Posts */}
            {relatedApps.length > 0 && (
                <section className="related-posts">
                    <h2 className="related-posts-title">Related articles</h2>
                    <div className="games-grid">
                        {relatedApps.slice(0, 8).map((post) => (
                            <Link to={`/blog/${post.slug}`} key={post.id} className="game-card" style={{textDecoration: "none"}}>
                                <div className="game-image" style={{
                                    background: "linear-gradient(45deg, #f093fb, #f5576c)",
                                    backgroundImage: `url(${post.featured_image_url})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center"
                                    }}>
                                    
                                    <div className="game-icon"
                                        style={{
                                            backgroundImage: `url(${post.avatar_url})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center"
                                        }}>
                                    </div>
                                </div>
                                <div className="game-info">
                                    <div className="game-title">{post.title}</div>
                                    <div className="game-developer">{post.category} • {Math.ceil(post.content.split(" ").length / 200)} min read</div>
                                    <div className="game-rating">
                                        <span className="rating-text">{formatDate(post.created_at)}</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </section>
            )}

            {/* Newsletter */}
            <section className="newsletter-box">
                <h3 className="newsletter-title">Never miss an update</h3>
                <p className="newsletter-description">
                    Subscribe to our newsletter for the latest gaming news, reviews, and exclusive content.
                </p>

                <form className="newsletter-form" onSubmit={handleSubmit}>
                    <input
                    type="text"
                    placeholder="Your name (optional)"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="newsletter-input"
                    />
                    <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="newsletter-input"
                    required
                    />
                    <button type="submit" className="newsletter-button" disabled={loading}>
                    {loading ? "Subscribing..." : "Subscribe"}
                    </button>
                </form>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
            </section>
        </main>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full page center
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Add global keyframes for spinner
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`,
  styleSheet.cssRules.length
);

export default SingleBlogPost;
